// extracted by mini-css-extract-plugin
export var container = "pricingAddOns-module--container--8b720";
export var content = "pricingAddOns-module--content--5e135";
export var description = "pricingAddOns-module--description--81ada";
export var icon = "pricingAddOns-module--icon--20430";
export var link = "pricingAddOns-module--link--c9e84";
export var linkText = "pricingAddOns-module--linkText--722cd";
export var price = "pricingAddOns-module--price--8f5d2";
export var priceContainer = "pricingAddOns-module--price-container--50a82";
export var title = "pricingAddOns-module--title--2f97c";